import { render, staticRenderFns } from "./AppointmentIndexComponent.vue?vue&type=template&id=726b1929"
import script from "./AppointmentIndexComponent.vue?vue&type=script&lang=js"
export * from "./AppointmentIndexComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports